export const EXTERNAL_USER_ID = "external_user_id";
